import { render } from "./FooterComponent.vue?vue&type=template&id=497d4416&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=497d4416&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497d4416"]])

export default __exports__